export const RankingsHeaders =  [
	{ label: 'Week No', key: 'weekNo' },
    { label: 'Ranking No', key: 'rankingNo' },
    { label: 'Team Name', key: 'teamName' },
	{ label: 'Events', key: 'evt' },
    { label: 'Tier One', key: 'tr1' },
    { label: 'Average', key: 'avg' },
    { label: 'axEF', key: 'axEF' },    
    { label: 'pPx2', key: 'pPx2' },    
    { label: 'Total', key: 'total' },    
    { label: 'Prv', key: 'prv' },    
    { label: 'Diff', key: 'diff' },    
    { label: 'Plus Min', key: 'plusMin' }
 ]

 export const ScheduleResultsHeaders =  [
	{ label: 'Event Date', key: 'eventDate' },
    { label: 'Event Name', key: 'eventName' },
    { label: 'Location', key: 'location' },
	{ label: 'Date Start', key: 'dateStart' },
    { label: 'Date End', key: 'dateEnd' },
    { label: 'Event Month', key: 'eventMonth' },
    { label: 'Event Season', key: 'eventSeason' }
 ]

 export const TeamStandingsHeaders =  [
	{ label: 'No', key: 'no' },
    { label: 'Team Name', key: 'teamName' },
    { label: 'Team', key: 'teamS' },
	{ label: 'Baker', key: 'bkr' },
    { label: 'Games', key: 'gm' },
    { label: 'Avg', key: 'avg' },
    { label: 'Diff', key: 'diff' }
 ]

 export const EventAverageHeaders =  [
	{ label: 'No', key: 'no' },
    { label: 'Name', key: 'name' },
    { label: 'School', key: 'school' },
	{ label: 'Tm', key: 'tm' },
    { label: 'Total', key: 'total' },
    { label: 'Gm', key: 'gm' },
    { label: 'Avg', key: 'avg' }
 ]

 export const SchoolAverageHeaders =  [
	{ label: 'No', key: 'no' },
    { label: 'Name', key: 'name' },
    { label: 'School', key: 'school' },
	{ label: 'Tm', key: 'tm' },
    { label: 'Total', key: 'total' },
    { label: 'Gm', key: 'gm' },
    { label: 'Avg', key: 'avg' }
 ]

 export const PlayerProfileHeaders =  [
	{ label: 'Event', key: 'event' },
    { label: 'Tr', key: 'tr' },
    { label: 'Dv', key: 'dv' },
	{ label: 'Total', key: 'total' },
    { label: 'Gm', key: 'gm' },
    { label: 'Avg', key: 'avg' },
    { label: 'Pos', key: 'pos' },
    { label: 'Bwl', key: 'bwl' },
    { label: 'Tms', key: 'tms' },
    { label: 'Adiff', key: 'adiff' },
    { label: 'E', key: 'e' },
    { label: 'Top1', key: 'top1' },
    { label: 'Top5', key: 'top5' },
    { label: 'Top10', key: 'top10' },
    { label: 'Top25', key: 'top25' },
    { label: 'Pct', key: 'pct' }
 ]

 export const TeamPowerPointHeaders =  [
    { label: 'Tier', key: 't1no' },
    { label: 'Tno', key: 'tno' },
    { label: 'Fin', key: 'fin' },
    { label: 'Tms', key: 'tms' },
	{ label: 'Event', key: 'tevent' },
    { label: 'Bpts', key: 'bpts' },
    { label: 'Tpts', key: 'tpts' },
    { label: 'Total', key: 'total' }
 ]

 export const EventPowerPointHeaders =  [
    { label: 'Pos', key: 'pos' },
    { label: 'Team Name', key: 'teamName' },
    { label: 'Base', key: 'base' },
    { label: 'Tms', key: 'tms' },
    { label: 'Total', key: 'total' }
 ]
 export const PlayersHeaders =  [
    { label: 'No', key: 'no' },
    { label: 'Player Name', key: 'playerName' },
    { label: 'School Name', key: 'schoolName' },
    { label: 'Gm', key: 'gm' },
    { label: 'Avg', key: 'avg' },
    { label: 'E', key: 'e' },
    { label: 'Top 1', key: 'top1' },
    { label: 'Top 5', key: 'top5' },
    { label: 'Top 10', key: 'top10' },
    { label: 'Top 25', key: 'top25' },
    { label: 'Field Avg', key: 'favg' },
    { label: 'Avg Diff', key: 'adiff' }
 ]

 export const UpcomingEventsHeaders =  [
    { label: 'Event Date', key: 'date' },     
    { label: 'Event Name', key: 'name' },
    { label: 'Center', key: 'centerName' },
    { label: 'Center Address', key: 'address' },
    { label: 'Center City', key: 'city' },
    { label: 'Center State', key: 'state' },    
    { label: 'Center Zip', key: 'zipcode' },
    { label: 'Director Name', key: 'directorName' },
    { label: 'Director Address', key: 'directorAddressLines' },
    { label: 'Director City', key: 'directorCity' },
    { label: 'Director State', key: 'directorState' },
    { label: 'Director Zipcode', key: 'directorZipCode' },
    { label: 'Director Email', key: 'directorSSOEmail' }
 ]







// WEBPACK FOOTER //
// ./src/utils/constants/exportHeaders.js